export default __webpack_public_path__ + "static/media/une (1).e9e898a2.png";